<!-- <div class=" shadow-sm" style="overflow:scroll; height:100%">
      <div *ngFor="let each of msg">
            <div *ngIf="each.check" class="text-light bg-success" style="margin-left: 350px; border-radius: 10px ">
                  <p [class.bg-danger]="each.seen" class="text-center m-1" >{{each.text}}</p>
                  <p style="margin-left: 140px">{{each.n}}</p>
            </div>
            <div *ngIf="!each.check" class="bg-dark text-light" style="margin-right: 350px;border-radius: 10px; ">
                  <p class="text-center m-1 ">{{each.text}}  </p>
                  <p style="margin-right: 40px">{{each.n}}</p>
            </div>
      </div>
        <div style="margin-top:90%; background-color: lightgrey">
            <input type="text"  style="float:left; width:90%; border-radius:5px;height: 30px;" [(ngModel)] ="message" >
            <span><button class="btn btn  fa fa-send-o" style="float:right;color:black " (click)="sendMessage()"></button></span>   
        </div>   

</div> -->




<div class=" shadow-sm" >
      <div style="overflow: auto;">
            <div *ngFor="let each of msg" >
                  <div *ngIf="each.check" class="text-light bg-success" style="margin-left: 350px; border-radius: 10px ">
                        <p [class.bg-danger]="each.seen" class="text-center m-1" >{{each.text}}</p>
                        <p style="margin-left: 140px">{{each.n}}</p>
                  </div>
                  <div *ngIf="!each.check" class="bg-dark text-light" style="margin-right: 350px;border-radius: 10px; ">
                        <p class="text-center m-1 ">{{each.text}}  </p>
                        <p style="margin-right: 40px">{{each.n}}</p>
                  </div>
            </div>
              <div  style=" background-color: lightgrey">
                  <input class="fixed-bottom" type="text"  style="border-radius:5px;height: 30px;margin-left: 40%; width: 600px;" [(ngModel)] ="message" >
                  <span><button class="btn btn  fa fa-send-o fixed-bottom" style="float:right;color:black; margin-left: 85%;" (click)="sendMessage()"></button></span>   
              </div>   
      </div>
</div>


